// extracted by mini-css-extract-plugin
export var hidden = "_ue-0";